export interface Service {
  slug: string;
  title: string;
  image: string;
  description: string;
}

export const services: Service[] = [
  {
    slug: "sports-medicine",
    title: "Sports Medicine Services",
    image: "/images/sports-medicine.png",
    description:
      "Comprehensive evaluation and treatment for sports-related injuries, performance optimization, and preventive care.",
  },
  {
    slug: "shoulder",
    title: "Shoulder",
    image: "/images/shoulder.png",
    description:
      "Treatment for rotator cuff tears, frozen shoulder, dislocations, and other shoulder injuries.",
  },
  {
    slug: "elbow-wrist-hand",
    title: "Elbow, Wrist & Hand",
    image: "/images/elbow-wrist-hand.png",
    description:
      "Specialized care for tennis elbow, carpal tunnel syndrome, fractures, and hand injuries.",
  },
  {
    slug: "back-neck",
    title: "Back & Neck",
    image: "/images/back-neck.png",
    description:
      "Non-surgical solutions for spinal injuries, herniated discs, and posture-related issues.",
  },
  {
    slug: "hip",
    title: "Hip",
    image: "/images/hip.png",
    description:
      "Comprehensive hip care including labral tears, arthritis management, and post-surgical rehabilitation.",
  },
  {
    slug: "knee",
    title: "Knee",
    image: "/images/knee.png",
    description:
      "ACL, meniscus, and ligament injury management with advanced rehabilitation techniques.",
  },
  {
    slug: "ankle-foot",
    title: "Ankle & Foot",
    image: "/images/ankle-foot.png",
    description:
      "Treatment for sprains, fractures, Achilles tendon injuries, and plantar fasciitis.",
  },
  {
    slug: "sports-injuries",
    title: "Sports Injuries",
    image: "/images/sports-injuries.png",
    description:
      "Injury prevention, diagnosis, and recovery for athletes across multiple sports.",
  },
  {
    slug: "prp-stem-cell",
    title: "PRP & Stem Cell Therapy",
    image: "/images/prp-stem-cell.png",
    description:
      "Regenerative therapies that accelerate healing and restore joint function naturally.",
  },
  {
    slug: "sports-science",
    title: "Sports Science Services",
    image: "/images/sports-science.png",
    description:
      "Performance testing, biomechanics analysis, and tailored athlete training programs.",
  },
  {
    slug: "sports-therapy",
    title: "Sports Therapy",
    image: "/images/sports-therapy.png",
    description:
      "Physiotherapy and rehabilitation programs designed for sports professionals and active individuals.",
  },
  {
    slug: "sports-psychology",
    title: "Sports Psychology",
    image: "/images/sports-psychology.png",
    description:
      "Mental coaching, stress management, and focus training for peak athletic performance.",
  },
  {
    slug: "runner-cyclist",
    title: "Runner and Cyclist",
    image: "/images/runner-cyclist.png",
    description:
      "Specialized care for running and cycling injuries, endurance optimization, and gait analysis.",
  },
];
